import { AspectRatio } from "./domain/AspectRatio";
import { ImageSize } from "./domain/ImageSize";

export const sizesByAspectRatio: {
  [key in AspectRatio]: ImageSize[];
} = {
  "16:9": [
    { width: 384, height: 216 },
    { width: 560, height: 315 },
    { width: 768, height: 432 },
    { width: 1360, height: 765 },
    { width: 2400, height: 1350 },
  ],
  "4:5": [
    { width: 200, height: 250 },
    { width: 400, height: 500 },
    { width: 800, height: 1000 },
    { width: 1200, height: 1500 },
    { width: 1600, height: 2000 },
  ],
  "2:3": [
    { width: 80, height: 120 },
    { width: 338, height: 507 },
    { width: 550, height: 825 },
    { width: 1000, height: 1500 },
    { width: 1500, height: 2250 },
  ],
  "0:0": [
    { width: 200, height: 0 },
    { width: 400, height: 0 },
    { width: 800, height: 0 },
    { width: 1200, height: 0 },
    { width: 1600, height: 0 },
  ],
  "1:1": [
    { width: 128, height: 128 },
    { width: 338, height: 338 },
    { width: 550, height: 550 },
    { width: 1000, height: 1000 },
    { width: 1500, height: 1500 },
    { width: 2000, height: 2000 },
  ],
  "1:2": [
    { width: 338, height: 676 },
    { width: 550, height: 1100 },
    { width: 1000, height: 2000 },
    { width: 1500, height: 3000 },
  ],
};
